import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types";
import { CustomerVoipConfig } from "@lib/types/Voip";

export const apiGetCustomerVoipConfig = async (configId: string) => {
  const url = `/customer-voip-config/${configId}`;
  return API.get<CustomerVoipConfig>(url);
};

export const apiUpdateCustomerVoipConfig = async (
  config: Partial<CustomerVoipConfig>,
) => {
  const { id } = config;
  const url = `/customer-voip-config/${id}`;
  return API.patch<CustomerVoipConfig>(url, config);
};

export const apiReplaceCustomerVoipConfig = async (
  config: CustomerVoipConfig,
) => {
  const { id } = config;
  const url = `/customer-voip-config/${id}`;
  return API.put<CustomerVoipConfig>(url, config);
};

export const apiDeleteCustomerVoipConfig = async (
  config: CustomerVoipConfig,
) => {
  const { id } = config;
  const url = `/customer-voip-config/${id}`;
  return API.delete<void>(url);
};

export const apiGetCustomerVoipConfigs = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/customer-voip-config` });
  return API.get<PaginationType<CustomerVoipConfig>>(url);
};

export const apiCreateCustomerVoipConfig = async (
  config: CustomerVoipConfig,
) => {
  const url = `/customer-voip-config`;
  return API.post<CustomerVoipConfig>(url, config);
};

export const apiBulkCreateCustomerVoipConfigs = async (
  configs: CustomerVoipConfig[],
) => {
  const url = `/customer-voip-config/bulk`;
  return API.post<CustomerVoipConfig[]>(url, configs);
};
